import React from "react";
import config from "../../config/index";
import { typeParam } from "./tools";
import { get } from "../../utils";

const checkFormBtn = function (props) {
  if (["reset", "submit"].includes(props.actionType)) {
    if (!Object.keys(props).includes("form")) {
      return {
        message: `当类型为 ${props.actionType} 时 ，form应该有值`,
        field: "props.form",
      };
    }
    return true;
  }
  return true;
};

const jumpBtn = function (props) {
  if (get(props, "actionType", "action"))
    if (props.actionType === "jump") {
      if (
        [props.path, props.href].every((p) => [undefined, null, ""].includes(p))
      ) {
        return {
          message: "当类型为 jump 时 并且href为空时，path应该有具体值",
          field: "props.path",
        };
      }
      return true;
    }
  return true;
};

const checkType = function (props) {
  const baseList = Object.keys(typeParam());
  const extraTypeList = props.extraTypeList || []; // 自己组件定义额外的类型
  const type = get(props, "actionType", "action");
  const typeList = baseList.concat(extraTypeList);
  if (!typeList.includes(type)) {
    return {
      message: `当前传入类型 【${type}】 不支持，支持的类型有【 ${typeList.join(
        ", "
      )} 】`,
      field: "props.actionType",
    };
  }
  return true;
};

const checkProps = function (props) {
  if (process.NODE_ENV === "production") {
    return [];
  }
  const result = [];
  const handles = [checkType, jumpBtn, checkFormBtn];
  for (let handle of handles) {
    const resolve = handle(props);
    if (resolve !== true) {
      result.push(resolve);
    }
  }
  return result;
};

export default function (props) {
  if (config.check === false) return null;
  const check = checkProps(props);
  if (check.length !== 0) {
    return (
      <div>
        参数错误
        {check.map((err) => {
          return (
            <div style={{ display: "flex", color: "red" }}>
              {`字段：${err.field}  ,  消息：${err.message}`}
            </div>
          );
        })}
      </div>
    );
  }
  return null;
}



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxAction/check.js